import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
let jmoment = require('jalali-moment');

@Pipe({ name: 'momentFormat' })
export class MomentFormatPipe implements PipeTransform {
    transform(value: moment.MomentInput, format: string) {
        if (!value) {
            return '';
        }

        // return moment(value).format(format);
        return jmoment(jmoment.from(value['_i'], 'fa', "YYYY-MM-DDTHH:mm:ss").format('YYYY-MM-DDTHH:mm:ss'), 'YYYY-MM-DDTHH:mm:ss').locale('fa').format(format);

    }
}
